/**
 * @file
 * The main, global JS file.
 *
 * This JS file will be included globally in the project.
 */

(($, Drupal) => {
  Drupal.behaviors.gcsu_main = {
    attach() {
      $(document).ready(() => {
        if (window.location.hash) {
          $("html,body")
            .stop()
            .animate(
              {
                scrollTop: $(window.location.hash).offset().top - 57,
              },
              500
            );
        }

        $("a[href^='#']").on("click", (e) => {
          const anchorLink = $(e.target).attr("href");
          e.preventDefault();
          $("html,body")
            .stop()
            .animate(
              {
                scrollTop: $(anchorLink).offset().top - 57,
              },
              500
            );
        });
      });
    }, // End of Drupal attach.
  };
})(jQuery, Drupal);
